module.exports = __webpack_public_path__ + "img/mobile_header.ac0bf5b3.svg";